import isType from './is-type';

const isDate = function(value: any): value is Date {
  return isType(value, 'Date');
};

export default isDate;
